export const BOOKING_URL = "https://secure.foratravel.com/intake/enchante/1Cvu6O1xmO";
export const FORA_URL = "https://www.foratravel.com/uk";
export const FOUNDER_NAME = "Latifa Al Khalifa";
export const LINKEDIN_URL = "https://www.linkedin.com/in/latifa-al-khalifa-42ab3a19/";
export const CONTACT_EMAIL = "latifa.fares@fora.travel";
export const EMAIL_COMPOSE_URL = `https://mail.google.com/mail/?view=cm&fs=1&to=${CONTACT_EMAIL}&su=${encodeURIComponent(
  "Enchanté — Frieze Abu Dhabi enquiry"
)}`;

export const TITLE_LINES = ["Art-world", "travel,", "handled."];

export const ADVISORY_INTRO =
  "For galleries and collectors at art fairs across the Arab world. We plan the week around the fair, drawing on fifteen years of curating in the region.";

export const FEE_NOTE =
  "Hotels, chauffeur, airport services and fair VIP programmes are paid separately.";

export const FEES = [
  { label: "Individual", price: "$750" },
  { label: "Couple", price: "$1,200" },
  { label: "Groups of 3+", price: "$1,750" },
];

// Placeholder photography — swap the `image` URLs when the final assets are ready.
export const CITIES = [
  {
    id: "abu-dhabi",
    slug: "frieze-abu-dhabi",
    index: "01",
    country: "AE",
    date: "Nov 2026",
    name: "Abu Dhabi",
    fair: "Frieze Abu Dhabi",
    dates: "19–22 November 2026",
    preview: "VIP programme from 16 November",
    venue: "Manarat Al Saadiyat",
    badge: "Now booking",
    image:
      "https://images.unsplash.com/photo-1552252415-5eb87e0fc788?auto=format&fit=crop&q=80&w=1600",
    alt: "Louvre Abu Dhabi dome over the water",
  },
  {
    id: "doha",
    slug: "art-basel-qatar",
    index: "02",
    country: "QA",
    date: "Jan 2027",
    name: "Doha",
    fair: "Art Basel Qatar",
    dates: "28–30 January 2027",
    preview: "Preview 26–27 January",
    venue: "Msheireb Downtown Doha",
    image:
      "https://images.unsplash.com/photo-1720276790084-67b1589613c4?auto=format&fit=crop&q=80&w=1600",
    alt: "National Museum of Qatar",
  },
  {
    id: "marrakech",
    slug: "1-54-marrakech",
    index: "03",
    country: "MA",
    date: "Mar 2027",
    name: "Marrakech",
    fair: "1-54 Marrakech",
    dates: "20–21 March 2027",
    preview: "Preview 18–19 March",
    venue: "La Mamounia",
    image:
      "https://images.unsplash.com/photo-1760386366084-1f2a4537280c?auto=format&fit=crop&q=80&w=1600",
    alt: "Brick facade of the Musée Yves Saint Laurent, Marrakech",
  },
  {
    id: "dubai",
    slug: "art-dubai",
    index: "04",
    country: "AE",
    date: "Apr 2027",
    name: "Dubai",
    fair: "Art Dubai",
    dates: "9–11 April 2027",
    preview: "Preview 7–8 April",
    venue: "Madinat Jumeirah · Sharjah Biennial 17 runs to 13 June",
    image:
      "https://images.unsplash.com/photo-1615747476328-41153cf6da54?auto=format&fit=crop&q=80&w=1600",
    alt: "White concrete pavilion against the Dubai skyline",
  },
];

export const INCLUDED_INTRO = [
  "We plan your week around the fair, from preview day to your last dinner.",
  "We make every booking: your hotel, your chauffeur, your restaurant tables. And we stay on call until you fly home.",
];

export const SERVICES = [
  {
    title: "Bespoke itinerary",
    copy: "A day-by-day plan built around fair hours, gallery openings and museum programmes.",
  },
  {
    title: "VIP fair membership",
    copy: "The right VIP programme for each fair, with a special price.",
  },
  {
    title: "Private chauffeur",
    copy: "Airport, fair and dinner transfers on your schedule.",
  },
  {
    title: "Airport meet-and-assist",
    copy: "Met on arrival and walked through immigration and baggage.",
  },
  {
    title: "Dining reservations",
    copy: "Tables requested across the week, from fair-day lunches to late dinners.",
  },
];

export const HOTEL_BENEFITS = {
  subline: "Exclusive perks when you book through us, at the same rate as booking direct.",
  everyStay: ["Daily breakfast", "A hotel or spa credit", "Priority status with the hotel"],
  whenAvailable: ["Room upgrade", "Early check-in", "Late checkout"],
  note: "Benefits vary by hotel and are confirmed at booking.",
};
